import { render } from "./AiAssistantWidget.vue?vue&type=template&id=49838a4a&scoped=true"
import script from "./AiAssistantWidget.vue?vue&type=script&lang=js"
export * from "./AiAssistantWidget.vue?vue&type=script&lang=js"

import "./AiAssistantWidget.vue?vue&type=style&index=0&id=49838a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49838a4a"]])

export default __exports__